import React from "react";
import Joi from "joi-browser";
import Form from "./common/form";
import auth from "../services/authService";
import { Redirect } from "react-router-dom";
import BlockUi from "react-block-ui";
import { Table, Grid } from "semantic-ui-react";

class LoginForm extends Form {
  state = {
    data: { username: "", password: "" },
    errors: {},
  };

  schema = {
    username: Joi.string().required().label("Username"),
    password: Joi.string().required().label("Password"),
  };

  componentDidMount() {
    document.body.style.backgroundImage = "url('./new_theme/accounting2.jpg')";
  }

  doSubmit = async () => {
    try {
      this.state.blocking = true;
      const { data } = this.state;

      await auth.login(data.username, data.password);
      this.state.blocking = false;

      window.location = "/dashboard";
    } catch (ex) {
      this.state.blocking = false;
      if (ex.response && ex.response.status === 401) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data.error;
        this.setState({ errors });
      }
    }
  };

  render() {
    const logoUrl = process.env.REACT_APP_URL + "/logo.jpg";
    if (auth.getCurrentUser()) return <Redirect to="/dashboard" />;
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <center>
          <form className="ui form" onSubmit={this.handleSubmit}>
            <Grid>
              {/* <Grid.Row>
                <Grid.Column width={5}></Grid.Column>
                <Grid.Column width={6}>
                  <img height="70" src={logoUrl} />
                </Grid.Column>
                <Grid.Column width={5}></Grid.Column>
              </Grid.Row> */}
              <Grid.Row>
                <Grid.Column width={5}></Grid.Column>
                <Grid.Column width={5}>
                  <div style={{ color: "#fff" }}>
                    <div
                      style={{
                        fontSize: "16px",
                        marginTop: "20px",
                        color: "#000",
                      }}
                    >
                      Welcome
                    </div>
                    <div style={{ marginTop: "20px" }}>
                      {/* <img width="100" src="new_theme/alpha.png" /> */}
                      <img width="200" src="new_theme/gondalgroup.png" />
                      {/* <img width="120" src="new_theme/gondalism.png" /> */}
                    </div>
                    <div
                      style={{ marginTop: "20px", width: "70%", color: "#000" }}
                    >
                      The SaaS E-Solutions for the online business in the
                      rapidly expanding market.
                    </div>

                    <div
                      style={{
                        marginTop: "20px",
                        marginBottom: "25px",
                        marginLeft: "65px",
                        marginRight: "50px",
                      }}
                    >
                      {/* <Input onChange={this.handleChange} style={{ width:'70%',marginLeft:'15px' }} icon="user" placeholder='Username' /> */}
                      {this.renderInput("username", "", "text")}
                    </div>
                    <div style={{ marginLeft: "65px", marginRight: "50px" }}>
                      {/* <Input onChange={this.handleChange} style={{ width:'70%',marginLeft:'15px' }} icon="key" placeholder='Password' /> */}
                      {this.renderInput("password", "", "password")}
                    </div>
                    <div style={{ marginTop: "25px", marginBottom: "25px" }}>
                      {this.renderButton("Login")}
                    </div>
                    {/* <div style={{ marginBottom:'20px',color:'#000' }}>
                    Forgot Password?
                  </div>   */}
                    <div style={{ color: "#000" }}>
                      All Rights Reserved By VAST Technology Solutions.
                    </div>
                  </div>
                  {/* <Table size="small">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell colspan="2">Login</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      <Table.Row width="8">
                        <Table.Cell>
                          {this.renderInput("username", "Username", "text")}
                        </Table.Cell>
                      </Table.Row>

                      <Table.Row width="8">
                        <Table.Cell>
                          {this.renderInput("password", "Password", "password")}
                        </Table.Cell>
                      </Table.Row>

                      <Table.Row>
                        <Table.Cell>{this.renderButton("Login")}</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table> */}
                </Grid.Column>
                <Grid.Column width={5}></Grid.Column>
              </Grid.Row>
            </Grid>
          </form>
        </center>
      </BlockUi>
    );
  }
}

export default LoginForm;
